// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Icon__Jsx3 = require("../Icon/Icon__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var ReactAriaComponents = require("react-aria-components");
var VisuallyHidden = require("@reach/visually-hidden").default;

var ReactChildren = {};

function PillLabel(props) {
  var closeHandler = props.closeHandler;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.children
                    }),
                closeHandler !== undefined ? JsxRuntime.jsxs(ReactAriaComponents.Button, {
                        children: [
                          JsxRuntime.jsx(VisuallyHidden, {
                                children: "Remove"
                              }),
                          JsxRuntime.jsx("span", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "CancelCircled",
                                      color: Theme__Color__Vars.chicago
                                    }),
                                "aria-hidden": true,
                                className: "flex ml-2.5 rounded-full outline outline-tan-blue-500 outline-0 group-focus-visible:outline-2 group-data-[focus-visible]:outline-2"
                              })
                        ],
                        className: (function (param) {
                            return "group appearance-none bg-transparent border-0 p-0 m-0 inline-flex items-center rounded focus:outline-none";
                          }),
                        onClick: (function (param) {
                            closeHandler();
                          })
                      }) : null
              ],
              className: "inline-flex items-center text-base leading-[1] py-1.5 pl-2 pr-1.5 rounded-2xl border border-zinc-300 bg-zinc-100 text-zinc-500 whitespace-nowrap"
            });
}

function PillLabel$Group(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var items = React.Children.toArray(props.children);
  return JsxRuntime.jsx("ul", {
              children: items.map(function (child) {
                    return JsxRuntime.jsx("li", {
                                children: child,
                                className: "flex mb-2 mr-2 last:mr-0"
                              });
                  }),
              "aria-label": props.ariaLabel,
              className: TailwindMerge.twMerge([
                    "flex flex-wrap mt-2",
                    className
                  ])
            });
}

var Group = {
  make: PillLabel$Group
};

var make = PillLabel;

exports.ReactChildren = ReactChildren;
exports.make = make;
exports.Group = Group;
/* react Not a pure module */
